import { FooterContent } from "../Footer";

interface FooterSectionProps {
  title: string;
  items: FooterContent[];
  renderContent: (item: FooterContent) => React.ReactNode;
}

export function FooterSection({ title, items, renderContent }: FooterSectionProps) {
  // Filter out duplicate items based on title and link_url
  const uniqueItems = items.reduce((acc: FooterContent[], current) => {
    // Special case for privacy policy - only keep the first occurrence
    if (current.link_url?.includes('/privacy')) {
      const hasPrivacyPolicy = acc.some(item => item.link_url?.includes('/privacy'));
      if (hasPrivacyPolicy) {
        return acc;
      }
    }

    const isDuplicate = acc.some(
      item => 
        item.title === current.title && 
        item.link_url === current.link_url
    );
    if (!isDuplicate) {
      acc.push(current);
    }
    return acc;
  }, []);

  const sectionTitle = title === 'legal' ? 'Informations légales' : 
                      title === 'company' ? 'Entreprise' :
                      title === 'contact' ? 'Contact' :
                      title.charAt(0).toUpperCase() + title.slice(1);
  
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider">
        {sectionTitle}
      </h3>
      <ul className="mt-4 space-y-2">
        {uniqueItems.map((item) => (
          <li key={item.id}>
            {renderContent(item)}
          </li>
        ))}
      </ul>
    </div>
  );
}
